import eight from '../assets/svg/projects/eight.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'bain-school',
        projectDesc: 'This project is about simplifying the development of smart school & education platForm.',
        tags: ['Laravel', 'Ajax', 'javaScript Bootstrap'],
        code: 'https://github.com/abdalrahman1990/',
        demo: 'https://www.smart-parking.tech/school/',
        image: six
    },
    {
        id: 2,
        projectName: 'Manara Center Project',
        projectDesc: 'A system for managing students, teachers, courses, payments, and exams efficiently in education centers',
        tags: ['Laravel', 'JavaScript', 'Bootstrap'],
        code: 'https://github.com/abdalrahman1990/',
        demo: 'https://www.smart-parking.tech/manara/public/',
        image: seven
    },
    {
        id: 3,
        projectName: 'Lun Development',
        projectDesc: 'This website to manage companys operations.',
        tags: ['Anqular', 'Laravel', 'Material Ui'],
        code: 'https://github.com/abdalrahman1990/lun',
        demo: 'http://lun.sa/',
        image: eight
    },

    {
        id: 4,
        projectName: 'LastCloud',
        projectDesc: 'This project is a Server and Hosting shop, Customer can be buy server, vps, storage,ssl and manage them and make payment.',
        tags: ['Pure PHP', 'Ajax', 'Css'],
        code: 'https://github.com/abdalrahman1990/',
        demo: 'http://testing.lastcloud.com.au/',
        image: seven
    },

]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/